<template>
  <v-container>
    <Navigation />
    <v-col
      cols="12"
      sm="12"
      xs="4"
      class="ml-2"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <div class="container mx-5">
        <TableWithSearch
          :headers="allHeaders"
          :items="getLevels"
          :openDialog="openDialog"
          :title="title"
          @headersUpdated="updateHeaders"
        />
      </div>

      <v-dialog v-model="showAdd" max-width="400px" persisten>
        <v-card>
          <v-card-title class="flex-center">
            {{
              isEdit
                ? $tc("workflow.edit") + " " + $tc("workflow.level")
                : $tc("workflow.add") + " " + $tc("workflow.level")
            }}
          </v-card-title>

          <v-card-actions class="flex-center">
            <v-form ref="form" v-model="valid" style="width: 100%">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
              >
                {{ alertValidate }}</v-alert
              >
              <v-text-field
                v-model="data.name"
                outlined
                dense
                label="Nombre"
                :rules="rules"
              />
              <v-text-field
                v-model="data.value"
                outlined
                dense
                label="Valor"
                type="number"
                :rules="rules"
              />
            </v-form>
          </v-card-actions>
          <div class="d-flex justify-space-between pb-4 px-4">
            <v-btn class="bt-exit" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="validate">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDelete" max-width="300px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{ $tc("workflow.delete") + " " + $tc("workflow.level") }}
          </v-card-title>
          <v-card-actions class="flex-center">
            <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept mb-2" @click="deleteLevel">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-col>
    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
  </v-container>
</template>

<script>
import Navigation from "../commons/Navigation.vue";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import levels from "../../../store/workflow/levels";
import commons from "../../../store/workflow/commons";
import Alerts from "../../GestionEmpleados/commons/Alerts.vue";
import Loader from "../../Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Navigation,
    TableWithSearch,
    Alerts,
    Loader,
  },
  data() {
    return {
      title: "Niveles",
      titleTable: "WF_Niveles",
      search: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Valor",
          value: "value",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
      data: {
        name: null,
        value: null,
      },
      error: false,
      alertValidate: "",
      valid: true,
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      ok: false,
      showDelete: false,
      deleteItems: null,
      editItems: [],
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = true;
    levels
      .dispatch("getLevels")
      .then(() => {
        this.isLoading = false;
      })
      .catch((e) => console.log(e));
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getLevels() {
      return levels.state.levels;
    },
    showAdd: {
      get() {
        return commons.state.showAdd;
      },
      set(newValue) {
        return newValue;
      },
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
    isEdit: {
      get() {
        return commons.state.isEdit;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    cancel() {
      if (this.showAdd) {
        commons.commit("setShowAdd", false);
        this.showAdd = false;
        this.$refs.form.resetValidation();
        this.data = {
          name: null,
          value: null,
        };
      } else {
        this.showDelete = false;
      }
    },
    resetAlerts() {
      setTimeout(() => {
        this.errorAlert = false;
        this.ok = false;
      }, 2500);
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.addExecution();
          break;
        case "edit":
          this.editExecution(item);
          break;
        case "delete":
          this.deleteExecution(item);
          break;

        default:
          break;
      }
    },
    addExecution() {
      commons.commit("setShowAdd", true);
      commons.commit("setIsEdit", false);
    },
    //valida el formulario de edicion y add
    validate() {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    add() {
      this.isLoading = true;
      levels.commit("setNew", this.data);
      levels
        .dispatch("new")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se agrego el nuevo nivel";
          this.data = { name: null, value: null };
          this.$refs.form.resetValidation();
          this.resetAlerts();
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.showAdd = false;

      commons.commit("setShowAdd", false);
    },
    deleteExecution(item) {
      this.showDelete = true;
      this.deleteItems = item.id;
    },
    deleteLevel() {
      this.isLoading = true;
      levels.commit("setDeleteItem", this.deleteItems);
      levels
        .dispatch("delete")
        .then(() => {
          this.isLoading = false;
          this.ok = true;
          this.textAlertOk = "Se elimino correctamente";
        })
        .catch((e) => {
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
          this.resetAlerts();
        });
      this.showDelete = false;
    },
    editExecution(item) {
      commons.commit("setShowAdd", true);
      this.showAdd = true;
      commons.commit("setIsEdit", true);
      this.isEdit = true;
      this.data = {
        value: item.value,
        name: item.name,
      };
      this.editItems = {
        id: item.id,
      };
    },
    edit() {
      this.editItems = {
        ...this.editItems,
        value: this.data.value,
        name: this.data.name,
      };
      this.isLoading = true;
      levels.commit("setEdit", this.editItems);
      levels
        .dispatch("edit")
        .then(() => {
          this.isLoading = false;
          this.ok = true;
          this.textAlertOk = "Se edito correctamente";
          this.data = { name: null, value: null };
          this.$refs.form.resetValidation();
          this.resetAlerts();
        })
        .catch((e) => {
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      commons.commit("setShowAdd", false);
      this.showAdd = false;
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.flex-center {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 100%;
}
</style>
